import api from './index'
import {
  axios
} from '@/utils/request'

export function login (parameter) {
  return axios({
    url: '/blaze-sys/sys/login',
    method: 'post',
    data: parameter
  })
}

export function phoneLogin (parameter) {
  return axios({
    url: '/blaze-sys/sys/phoneLogin',
    method: 'post',
    data: parameter
  })
}

export function getSmsCaptcha (parameter) {
  return axios({
    url: api.SendSms,
    method: 'post',
    data: parameter
  })
}

export function getInfo () {
  return axios({
    url: '/blaze-sys/api/user/info',
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function logout (logoutToken, dds) {
  return axios({
    url: '/blaze-sys/sys/logout',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'X-Access-Token': logoutToken,
      'DDS': dds
    }
  })
}